// Global CSS classes
export enum GlobalClass {
  ButtonPlain = "buttonPlain",
  HideText = "hideText",
}
